// extracted by mini-css-extract-plugin
module.exports = {"guideRemind":"GuideRemind_guideRemind_2Cxeo","close":"GuideRemind_close_2LYb2","btnGroup":"GuideRemind_btnGroup_2F7ai","fullScreen":"GuideRemind_fullScreen_3sO9X"};